import { useEffect, useState } from 'react';

import { fetchServicesPublic } from '../lib/services';
import { getFileUrl } from '../lib/pb';


export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const items = await fetchServicesPublic();
        if (!cancelled) {
          setServices(items || []);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e.message || 'Erreur lors du chargement des services');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 700);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const parsedServices = services.map(service => {
    let features = [];
    if (service.features) {
      if (Array.isArray(service.features)) {
        features = service.features;
      } else if (typeof service.features === 'string') {
        try {
          const parsed = JSON.parse(service.features);
          if (Array.isArray(parsed)) features = parsed;
        } catch {
          // ignore parse error
        }
      }
    }
    return { ...service, _features: features };
  });


  return (
    <div className="services-page-signature">
      <header className="services-header-signature">
        <div className="tag-line-premium">AEF 32 • EXPERTISE & ACCOMPAGNEMENT</div>
        <h1>Nos services</h1>
        <p className="services-subtitle">
          Étude, installation, maintenance et dépannage : découvrez comment AEF32 vous accompagne sur l&apos;ensemble de vos projets de portails et d&apos;automatismes.
        </p>
      </header>

      {loading && (
        <p style={{ textAlign: 'center', marginTop: 20 }}>Chargement des services…</p>
      )}

      {error && !loading && (
        <p style={{ color: 'crimson', textAlign: 'center', marginTop: 16 }}>{error}</p>
      )}

      {!loading && !error && !parsedServices.length && (
        <p style={{ textAlign: 'center', marginTop: 20 }}>Aucun service n&apos;est configuré pour le moment.</p>
      )}

      {!loading && !error && !!parsedServices.length && (
        <section style={{ marginTop: 28, marginBottom: 32 }}>
          <div
            style={{
              maxWidth: 1200,
              margin: '0 auto',
              padding: '0 20px',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: 20,
            }}
          >
            {parsedServices.map(service => (
              <article
                key={service.id}
                style={{
                  flex: isMobile ? '0 1 calc((100% - 20px) / 2)' : '0 1 260px',
                  width: isMobile ? 'calc((100% - 20px) / 2)' : 260,
                  boxSizing: 'border-box',
                  borderRadius: 16,
                  background: '#ffffff',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 10px 25px rgba(15,23,42,0.04)',
                  padding: 18,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 10,
                }}
              >
                {service.icon && (
                  <div style={{
                    width: 72,
                    height: 72,
                    borderRadius: 999,
                    background: '#f1f5f9',
                    border: '1px solid #e2e8f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    marginBottom: 4,
                    overflow: 'hidden',
                  }}>
                    <img
                      src={getFileUrl(service, service.icon)}
                      alt={service.title}
                      style={{ width: '70%', height: '70%', objectFit: 'contain' }}
                    />
                  </div>
                )}

                <h2 style={{ margin: '0 0 4px 0', fontSize: 18 }}>{service.title}</h2>

                {service.excerpt && (
                  <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>{service.excerpt}</p>
                )}

                {!!service._features.length && (
                  <ul style={{
                    margin: '8px 0 0 0',
                    paddingLeft: 18,
                    fontSize: 13,
                    color: '#4b5563',
                  }}>
                    {service._features.slice(0, 4).map((f, idx) => (
                      <li key={idx}>{f}</li>
                    ))}
                    {service._features.length > 4 && (
                      <li>…</li>
                    )}
                  </ul>
                )}
              </article>
            ))}
          </div>
        </section>
      )}

      <section className="services-proximity-section">
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px' }}>
          <div className="proximity-card-elite shadow-signature">
            <div className="proximity-content-grid">
              <div className="proximity-text">
                <h2 className="title-with-accent">Un projet de portail ou d&apos;automatisme ?</h2>
                <p className="p-major">
                  Parlez-nous de votre besoin et bénéficiez d&apos;un accompagnement personnalisé par notre équipe.
                </p>
                <div className="proximity-badges-row">
                  <div className="p-badge"><div className="p-dot"></div> Fiabilité</div>
                  <div className="p-badge"><div className="p-dot"></div> Sécurité</div>
                  <div className="p-badge"><div className="p-dot"></div> Durabilité</div>
                </div>
                <div className="proximity-actions">
                  <a href="/contact" className="btn-emerald-signature-full">
                    Nous contacter <span className="arrow-icon">→</span>
                  </a>
                </div>
              </div>
              {!isMobile && (
                <div className="proximity-icon-box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="map-icon-luxury"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .services-page-signature { background: #fff; padding: 40px 0; font-family: 'Inter', sans-serif; }
        
        /* HEADER */
        .services-header-signature { text-align: center; margin-bottom: 60px; max-width: 960px; margin-left: auto; margin-right: auto; padding: 0 20px; }
        .tag-line-premium { 
           font-size: 11px; font-weight: 800; color: var(--accent); 
           letter-spacing: 2px; margin-bottom: 15px; 
        }
        .services-header-signature h1 { 
           font-size: clamp(32px, 5vw, 52px); font-weight: 900; 
           color: #0f172a; margin: 0 0 15px 0; letter-spacing: -1.5px;
        }
        .services-subtitle { font-size: 18px; color: #64748b; max-width: 700px; margin: 0 auto; line-height: 1.6; }

        /* PROXIMITY CTA */
        .services-proximity-section { margin-top: 80px; padding-bottom: 40px; }
        .proximity-card-elite { 
           background: #f0fdf4; border-radius: 36px; border: 1px solid #f1f5f9; padding: 60px;
           position: relative; overflow: hidden; text-align: left;
        }
        .proximity-content-grid { display: grid; grid-template-columns: 1fr 200px; gap: 40px; align-items: center; }
        .title-with-accent { font-size: 28px; font-weight: 950; color: #0f172a; margin-bottom: 25px; position: relative; letter-spacing: -1px; }
        .title-with-accent::after { content: ''; position: absolute; left: 0; bottom: -10px; width: 40px; height: 3px; background: var(--accent); }
        .p-major { font-size: 18px; color: #475569; line-height: 1.6; margin-bottom: 30px; max-width: 650px; }
        .proximity-badges-row { display: flex; gap: 20px; flex-wrap: wrap; margin-bottom: 40px; }
        .p-badge { 
           background: #fff; border: 1px solid #e2e8f0; padding: 8px 16px; border-radius: 12px;
           font-size: 12px; font-weight: 800; color: var(--accent); text-transform: uppercase; letter-spacing: 0.5px;
           display: flex; align-items: center; gap: 8px;
           box-shadow: 0 4px 10px rgba(0,0,0,0.02);
        }
        .p-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--accent); }
        
        .btn-emerald-signature-full {
           background: var(--accent); color: #fff; border: none; padding: 18px 40px; border-radius: 16px; 
           font-weight: 800; display: inline-flex; align-items: center; gap: 10px; cursor: pointer; transition: all 0.3s;
           text-decoration: none; box-shadow: 0 10px 25px rgba(34, 197, 94, 0.25);
        }
        .btn-emerald-signature-full:hover { transform: translateY(-3px); background: var(--accent-600); box-shadow: 0 15px 35px rgba(34, 197, 94, 0.3); }
        .arrow-icon { font-size: 20px; }

        .proximity-icon-box { display: flex; justify-content: center; }
        .map-icon-luxury { width: 120px; height: 120px; color: var(--accent); opacity: 0.15; }

        @media (max-width: 900px) {
           .proximity-content-grid { grid-template-columns: 1fr; }
           .proximity-card-elite { padding: 40px 30px; }
           .title-with-accent { font-size: 24px; }
           .btn-emerald-signature-full { width: 100%; justify-content: center; }
        }
      `}</style>
    </div>
  );
}
